import {Space} from "antd";
import {LiveEventOfferingFormGroups} from "../accordion/data";
import {applyOfferingFormFeatureFlags} from "../accordion/apply-feature-flags-to-form-groups";
import {OfferingFormAccordionItem} from "../accordion/accordion-item";
import {LiveEventOfferingFormProps} from "./types";
import {LiveEventEventTypeFormFields} from "./event-type";
import {LiveEventPricingFormFields} from "./pricing";
import {LiveEventSettingsFormFields} from "./settings";
import {SessionRedirectAfterPurchaseFormFields} from "../session-bundle/session/redirect-after-purchase";

export function LiveEventOfferingForm({
  isGeneralInformationError,
  isEventTypeError,
  isAttendeesError,
  isPricingError,
  isSettingsError,
  isLocationError,
  isCoverImagesError,
  formType,
}: LiveEventOfferingFormProps) {
  const formGroups = applyOfferingFormFeatureFlags(
    LiveEventOfferingFormGroups.filter((group) => {
      if (formType === "create") return group.title !== "Cover image";
      return true;
    })
  );
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {formGroups.map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Cover image") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isCoverImagesError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Event type") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isEventTypeError}
            >
              <LiveEventEventTypeFormFields formType={formType} />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              <LiveEventPricingFormFields />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Attendees") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isAttendeesError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Location") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isLocationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <LiveEventSettingsFormFields formType={formType} showUrlRedirect={false} />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <SessionRedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else {
          return null;
        }
      })}
    </Space>
  );
}
